import '../../App.css';
import Cards from '../Cards/Cards';
import Hero from '../HeroSection/Hero';
import Footer from '../Footer/Footer'

function Home() {
    return (
        <>
            <Hero />
            <Cards />
            <Footer />
        </>
    )
}

export default Home;